const AUTH_PATHS = new Set([
  '/login',
  '/sso',
  '/signup',
  '/forgot-password',
  '/reset_password',
  '/app/reset_password',
  '/app/forgot_password',
]);

export function safeNextPath(next) {
  if (!next || typeof next !== 'string') return null;
  try {
    const url = new URL(next, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    if (AUTH_PATHS.has(url.pathname)) return null;
    return url.pathname + url.search + url.hash;
  } catch (e) {
    return null;
  }
}
